import React, { FC, useEffect, useState } from 'react';
import ArrowDown from '../../../../../assets/icons/inline/arrow-donw.inline.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import * as classes from './IntroText.module.scss';
import { INTRO_TEXT_LIMIT } from '../../../../../constants/constants';

interface Props {
  introText: string;
}

const IntroText: FC<Props> = ({ introText }) => {
  const { t } = useTranslation();

  const [text, setText] = useState<string>();
  const [isButtonVisible, setIsButtonVisible] = useState(false);

  useEffect(() => {
    if (introText.length > INTRO_TEXT_LIMIT) {
      setText(introText.substring(0, INTRO_TEXT_LIMIT) + '...');
      setIsButtonVisible(true);
      return;
    }
    setText(introText);
  }, [introText]);

  const readMoreClickHandler = () => {
    setText(introText);
    setIsButtonVisible(false);
  };

  return (
    <>
      <div className={classes.text}>{!!text && <div dangerouslySetInnerHTML={{ __html: text }} />}</div>
      {isButtonVisible && (
        <div className={classes.button} onClick={readMoreClickHandler}>
          <span className={classes.buttonText}>{t('common.readMoreButtonText')}</span>
          <ArrowDown />
        </div>
      )}
    </>
  );
};

export default IntroText;
